/* eslint-disable max-len */
import angular from 'angular';
import { alerts } from 'app/components/global';
import {
  ssDialogService,
  loaderService,
  orgDataService
} from 'app/services';

import controller from './edit-user-dialog.controller';
import customerPermissionsDirective from './customer-permissions.directive';
import navantaPermissionsDirective from './navanta-permissions.directive';
import template from './edit-user-dialog.html';
import userEmailMessagesTpl from './messages/user.email.messages.html';
import userNameMessagesTpl from './messages/user.name.messages.html';
import userPhoneMessagesTpl from './messages/user.phone.messages.html';

export class dialogService {
  getOptions($event, {
    customerId = -1, customerHasUnverifiedEmailDomain = false, userId = -1, user = null, userRoles = null, refreshUser, isInvite = false, isNonAuthen = false, isADAuthen = false, isAzureAuthen = false, customerDomains
  }) {
    return {
      controller,
      controllerAs: 'editUserDialogVM',
      locals: {
        customerId,
        customerHasUnverifiedEmailDomain,
        userId,
        user,
        userRoles,
        refreshUser,
        isInvite,
        isNonAuthen,
        isADAuthen,
        isAzureAuthen,
        customerDomains
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.userAdmin.editUserDialog', [
  alerts,
  ssDialogService,
  loaderService,
  orgDataService,
])
  .service('editUserDialog', dialogService)
  .directive('customerPermissions', customerPermissionsDirective)
  .directive('navantaPermissions', navantaPermissionsDirective)
  .run(($templateCache) => {
    $templateCache.put('user.email.messages.html', userEmailMessagesTpl);
    $templateCache.put('user.name.messages.html', userNameMessagesTpl);
    $templateCache.put('user.phone.messages.html', userPhoneMessagesTpl);
    $templateCache.put('user.loginName.messages.html', userPhoneMessagesTpl);
  })
  .name;

console.log('app.components.admin.userAdmin.editUserDialog created');
